.video-hero {
  
    height: 481px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
  
    .video-holder {
      width: 100vw;
      position: relative;
      z-index: 1;
      height: 481px;
  
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 481px;
        background: linear-gradient(180deg, rgba(0, 60, 113, 1) 10%, rgba(0, 60, 113, 0) 100%);
        background-size: cover;
        background-position: center;
        z-index: 2;
        pointer-events: none;
      }

      &::before {
        position: absolute;
        content: '';
        height: 6px;
        width: 100%;
        background-color: #C6930A;
        bottom: 0;
        left: 0;
        z-index: 3;
      }
  
      video  {
        position: absolute;
        width: 100vw;
        height: 481px;
        object-fit: cover;
        object-position: 50% 30%; 
      }
      img {

        &.bg-image {
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          position: absolute;
          object-fit: cover;
          object-position: 50% 30%; 
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
        }
      }

      .video-hero-media {
        .custom-controls {

          button.video-hero-toggle {
            position: absolute;
            bottom: 25px;
            right: 85px;
            border-radius: 50%;
            border: none;
            background: transparent;
            z-index: 5;
            padding: 0;

            kdx-icon {
              display: block;

              &.play-icon { margin-right: -2px; }
              
              svg { @include svg-format(15px, 22px, $secondary); }
            }
    
    
            &::after {
                content: '';
                position: absolute;
                bottom: -8px;
                right: -13px;
                border-radius: 50%;
                background-color: #FFFFFF;
                width: 40px;
                height: 40px;
                z-index: -1;
                box-shadow: 0px 3px 6px #00000080;
            }
            &:hover, &:focus {

              svg { fill: #FFFFFF; }

              &::after { background-color: $secondary; }
            }
          }
        }
      }
    }
  
   

    .video-hero-content-wrapper {
      position: absolute;
      top: 50%;
      z-index: 1;
      left: 50%;
      width: auto;
      transform: translate(-50%, -50%);
    }
  
  
    &-content {
      width: 100%;
      padding: 16px 0;

      h1 {
        color: #FFFFFF;
        text-align: center;
        font-weight: 900;
      }
  
      p {
        margin-top: 16px;
        @include text-size(24);
        @include line-height(36);
        font-weight: 700;
        color: #FFFFFF;
        text-align: center;
      }
    }
  
    &-ctas {
      display: flex;
      align-items: flex-start;
      justify-content: center;
  
      a {
        flex-direction: column;
        text-align: center;
        margin: 0 10px;
  
        &.btn {
            font-weight: 700;
            
            &.btn-secondary {
                color: #FFFFFF;
            
                svg { fill: #FFFFFF; }
            }
       }
  
        img {
          max-height: 46px;
          max-width: 46px;
          margin-bottom: 8px;
        }
      }
    }
  
    @include media-breakpoint-down(lg) {
  
      a {
        > img {
          margin-right: auto;
          margin-left: auto;
        }
      }
      .video-holder {
        .video-hero-media {
          .custom-controls {
            button.video-hero-toggle {
              bottom: 75px;
            }
          }
        }
      }
      .video-hero-content {
        h1 {
          @include text-size(32);
          @include line-height(40);
        }

        p {
          @include text-size(19);
          @include line-height(28);
      }
      }
    }
  
    @include media-breakpoint-down(md) {
      height: 100%;
      width: 100%;
      margin: 0;
  
      .video-holder {
        transform: none;

        button.video-hero-toggle {
            bottom: 113px;
            right: 50px;
        }
      }

      .video-hero-content-wrapper {
        width: 100%;

        .video-hero-content {
  
          .video-hero-ctas {
              display: flex;
              flex-direction: column;
              align-items: center;

              a {
                  &.btn {
                      margin-bottom: 30px;
                      margin-right: 0;
                      margin-left: 0;
                  }
              }
          }
        }
      }
  
    }
  }